import { SystemDescriptions } from "src/common/descriptions";
import { searchableTableUtils } from "src/components/SearchableTable/utils";

const descriptions = SystemDescriptions.PAGES.CONTRACT_PAYMENT.CASHBOX_CATEGORIES

export enum ColumnsKeys {
    NO = 'key',
    NAME = 'name',
    DESCRIPTION = 'description',
    IS_EDITABLE = 'isEditable',
    TYPE = 'type',
}

export const TABLE_COLUMNS: any = [
    {
        title: descriptions.TABLE_COLUMNS.ID,
        dataIndex: ColumnsKeys.NO,
        key: ColumnsKeys.NO,
        align: searchableTableUtils.alignment.centerAlign,
    },
    {
        title: descriptions.TABLE_COLUMNS.NAME,
        dataIndex: ColumnsKeys.NAME,
        key: ColumnsKeys.NAME,
        align: searchableTableUtils.alignment.centerAlign,
    },
    {
        title: descriptions.TABLE_COLUMNS.DESCRIPTION,
        dataIndex: ColumnsKeys.DESCRIPTION,
        key: ColumnsKeys.DESCRIPTION,
        align: searchableTableUtils.alignment.centerAlign,
    },
    {
        title: descriptions.TABLE_COLUMNS.TYPE,
        dataIndex: ColumnsKeys.TYPE,
        key: ColumnsKeys.TYPE,
        align: searchableTableUtils.alignment.centerAlign,
        render: (value) => value === "I" ? descriptions.INCOME : descriptions.OUTCOME,
    },
];